import { featuresNames } from './features.data';

export interface IFeatureData {
  type: string;
  isActive: boolean;
  name: featuresNames;
}
